import './UilTimeline.css';

// School year months: August (0) through May (9)
const MONTHS = ['Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'];

const MONTH_INDEX = {
  August:    0,
  September: 1,
  October:   2,
  November:  3,
  December:  4,
  January:   5,
  February:  6,
  March:     7,
  April:     8,
  May:       9,
};

const TOTAL_MONTHS = MONTHS.length;

function pct(idx) {
  return `${(idx / TOTAL_MONTHS) * 100}%`;
}

function barWidth(startIdx, endIdx) {
  return `${((endIdx - startIdx + 1) / TOTAL_MONTHS) * 100}%`;
}

export default function UilTimeline({ sports }) {
  return (
    <div className="uil-timeline-wrapper" role="img" aria-label="UIL sports season calendar, August through May">
      <div className="uil-timeline">
        {/* Month header */}
        <div className="uil-timeline-header">
          <div className="uil-timeline-label-col" aria-hidden="true" />
          <div className="uil-timeline-track-col">
            <div className="uil-timeline-month-row" aria-hidden="true">
              {MONTHS.map(m => (
                <div key={m} className="uil-timeline-month">{m}</div>
              ))}
            </div>
          </div>
        </div>

        {/* Sport rows */}
        {sports.map(sport => {
          const startIdx = MONTH_INDEX[sport.seasonStart] ?? 0;
          const endIdx   = MONTH_INDEX[sport.seasonEnd]   ?? TOTAL_MONTHS - 1;
          return (
            <div key={sport.id} className="uil-timeline-row">
              <div className="uil-timeline-label-col">
                <span className="uil-timeline-sport-name">{sport.name}</span>
              </div>
              <div className="uil-timeline-track-col">
                <div className="uil-timeline-track">
                  <div
                    className="uil-timeline-bar"
                    style={{
                      left:  pct(startIdx),
                      width: barWidth(startIdx, endIdx),
                    }}
                    aria-label={`${sport.name}: ${sport.season}`}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
